import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiChargesMyGet } from '@/entities/charges/modules/api/charges';

// The caller's unpaid debt ledger (their own Cargo ID). Keyed under
// `parcels` so the realtime `parcels` push (sent on every charge change)
// refreshes it too.
export const useMyCharges = (enabled = true) =>
  useFetch({
    api: apiChargesMyGet,
    keywords: queryKeys.parcels.myCharges,
    enabled,
    staleTime: 30_000,
  });
